/* eslint-disable */
import { STATUS_COLORS } from 'constants/statuses';
import Collections from 'containers/Orders/Collections/Collections';
import Planning from 'containers/Orders/Planning/Planning';
import ProductionManager from 'containers/Orders/ProductionManager/ProductionManager';
import Shipments from 'containers/Orders/Shipments/Shipments';
import Loader from 'layout/atoms/Loader/Loader';
import ParameterDetails from 'layout/atoms/ParameterDetails/ParameterDetails';
import Pie from 'layout/atoms/Pie';
import StatsCard from 'layout/atoms/StatsCard/StatsCard';
import TabsButton from 'layout/atoms/TabsButton/TabsButton';
import Grid from 'layout/molecules/Grid/Grid';
import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { clearBreadcrumbs, setBreadcrumbs } from 'store/layoutSlice';
import { fetchOrder, fetchOrderComponentVariantStats, resetOrderDetailsState, selectOrderDetailsItem, selectOrderDetailsRefetchFlags, selectOrderDetailsStatus, } from 'store/orderDetailsSlice';
import Dashboard from 'templates/Dashboard/Dashboard';
import { getMenuLabel } from 'utils/getMenuItem';
const OrderDetails = () => {
    var _a;
    const { orderId } = useParams();
    const location = useLocation();
    const { t } = useTranslation(['orders', 'specification', 'common']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const status = useSelector(selectOrderDetailsStatus);
    const refetchFlags = useSelector(selectOrderDetailsRefetchFlags);
    const order = useSelector(selectOrderDetailsItem);
    const statsLoading = status.fetchComponentVariantStats === 'loading';
    const tabs = [
        { id: 'collections', label: t('collections') },
        { id: 'production-manager', label: t('production-manager') },
        { id: 'planning', label: t('planning') },
        { id: 'shipments', label: t('shipments') },
    ];
    const currentTab = ((_a = tabs.find((tab) => location.pathname.endsWith(`/${tab.id}`))) === null || _a === void 0 ? void 0 : _a.id) || 'collections';
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchOrder(orderId));
        }
    }, [dispatch, orderId, status, refetchFlags]);
    useEffect(() => {
        if (status.fetch !== 'succeeded') {
            return;
        }
        const needsInitialFetch = status.fetchComponentVariantStats === 'idle' && !(order === null || order === void 0 ? void 0 : order.componentVariantStats);
        const needsRefetch = refetchFlags.fetchComponentVariantStats;
        if (needsInitialFetch || needsRefetch) {
            dispatch(fetchOrderComponentVariantStats(orderId));
        }
    }, [
        dispatch,
        orderId,
        status.fetch,
        status.fetchComponentVariantStats,
        refetchFlags.fetchComponentVariantStats,
        order === null || order === void 0 ? void 0 : order.componentVariantStats,
    ]);
    useEffect(() => {
        const ordersLabel = getMenuLabel('/orders', t);
        const orderName = order === null || order === void 0 ? void 0 : order.orderId;
        const currentTabConfig = tabs.find((tab) => tab.id === currentTab);
        const tabLabel = (currentTabConfig === null || currentTabConfig === void 0 ? void 0 : currentTabConfig.label) || tabs[0].label;
        dispatch(setBreadcrumbs([
            { to: '/orders', name: ordersLabel },
            { to: `/orders/${orderId}`, name: orderName },
            { to: `/orders/${orderId}/${currentTab}`, name: tabLabel },
        ]));
        return () => {
            dispatch(clearBreadcrumbs());
        };
    }, [dispatch, t, orderId, order === null || order === void 0 ? void 0 : order.orderId, currentTab, tabs]);
    useEffect(() => {
        return () => {
            dispatch(resetOrderDetailsState());
        };
    }, []);
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'error') {
        return React.createElement("p", null, "error");
    }
    const stats = (order === null || order === void 0 ? void 0 : order.componentVariantStats) || {
        delayedCount: 0,
        withPlannedCount: 0,
        completelyDeliveredCount: 0,
    };
    return (React.createElement("div", { style: { paddingBottom: '76px' } },
        React.createElement(Dashboard, null,
            React.createElement(Grid, { vp: 16, hp: 20 },
                React.createElement(ParameterDetails, { size: "xl", label: t('order'), value: (order === null || order === void 0 ? void 0 : order.orderId) || '-' }),
                React.createElement(TabsButton, { tabs: tabs, activeTab: currentTab, onClick: (e) => navigate(`/orders/${orderId}/${e}`) }),
                React.createElement(Grid, { columns: 3 },
                    React.createElement(StatsCard, { color: "alert", label: t('STATUS_ERROR'), number: stats.delayedCount || 0, aside: React.createElement(Pie, { value: stats.delayedCount || 0, total: stats.totalComponentVariants, color: STATUS_COLORS.error, size: "m" }), loading: statsLoading }),
                    React.createElement(StatsCard, { color: "info", label: t('STATUS_IN_PROGRESS'), number: stats.withPlannedCount || 0, aside: React.createElement(Pie, { value: stats.withPlannedCount || 0, total: stats.totalComponentVariants, color: STATUS_COLORS['in-progress'], size: "m" }), loading: statsLoading }),
                    React.createElement(StatsCard, { color: "success", label: t('STATUS_DONE'), number: stats.completelyDeliveredCount || 0, aside: React.createElement(Pie, { value: stats.completelyDeliveredCount || 0, total: stats.totalComponentVariants, color: STATUS_COLORS.done, size: "m" }), loading: statsLoading }))),
            React.createElement(Routes, null,
                React.createElement(Route, { path: "collections", element: React.createElement(Collections, null) }),
                React.createElement(Route, { path: "production-manager", element: React.createElement(ProductionManager, null) }),
                React.createElement(Route, { path: "planning", element: React.createElement(Planning, null) }),
                React.createElement(Route, { path: "shipments", element: React.createElement(Shipments, null) }),
                React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: "collections", replace: true }) })))));
};
export default memo(OrderDetails);
